import { Icon } from "../components/Icon.js";
import { useAuth } from "../auth/AuthContext.js";

export function SettingsPage() {
  const { user } = useAuth();
  return (
    <div className="grid grid-cols-12 gap-gutter">
      <div className="col-span-12 bg-surface-container border border-outline-variant rounded-xl p-lg space-y-md">
        <div>
          <h1 className="text-headline-md text-on-surface">Settings</h1>
          <p className="text-body-sm text-on-surface-variant mt-1">
            Hub-wide configuration lives here. Per-account changes (password, name) will move into a separate
            Profile page.
          </p>
        </div>

        <Field label="Signed in as" value={user?.email ?? "—"} mono />
        <Field label="Role" value={user?.isAdmin ? "Admin" : "Member"} />
        <Field label="Hub origin" value="https://calsync.appsdo.in" mono />
      </div>

      <div className="col-span-12 bg-surface-container border border-outline-variant rounded-xl p-lg flex flex-col items-center text-center gap-md">
        <Icon name="construction" className="text-tertiary-container" style={{ fontSize: "48px" }} />
        <h2 className="text-headline-md text-on-surface">Real settings forms coming soon</h2>
        <p className="text-body-sm text-on-surface-variant max-w-md">
          OAuth client IDs, sync policy, retention windows, backup destinations, master-key rotation — these will
          all be editable here once the backend endpoints exist. For now, edit{" "}
          <code className="font-mono text-primary-fixed-dim">.env</code> on the VPS and restart the hub.
        </p>
      </div>
    </div>
  );
}

function Field({ label, value, mono }: { label: string; value: string; mono?: boolean }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-md items-center">
      <span className="text-label-xs font-mono text-on-surface-variant uppercase tracking-widest">{label}</span>
      <div
        className={`md:col-span-2 px-3 py-2 bg-surface-container-lowest border border-outline-variant rounded text-body-sm ${
          mono ? "font-mono" : ""
        }`}
      >
        {value}
      </div>
    </div>
  );
}
